import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddCountry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        name: "",
        isoName: "",
        iso3Name: "",
        niceName: "",
        callingCode: "",
        isActive: true,
      },
      nameError: "",
      isoNameError: "",
      iso3NameError: "",
      niceNameError: "",
      callingCodeError: "",
    };
  }

  handleChange = (checked) => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };

  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "name") {
      this.setState({
        value: { ...this.state.value, name: value },
      });
    } else if (name === "isoName") {
      this.setState({
        value: { ...this.state.value, isoName: value },
      });
    } else if (name === "iso3Name") {
      this.setState({
        value: { ...this.state.value, iso3Name: value },
      });
    } else if (name === "niceName") {
      this.setState({
        value: { ...this.state.value, niceName: value },
      });
    } else if (name === "callingCode") {
      this.setState({
        value: { ...this.state.value, callingCode: value },
      });
    }
  };

  validate = () => {
    let isError = false;
    let regex = /[a-z]|[a-z]\s/i;
    let regexcode = /^\+[0-9]|[0-9]/;

    const errmsg1 = "Enter a valid input";
    const errmsg2 = "This field cannot be empty";

    const errors = {
      nameError: "",
      isoNameError: "",
      iso3NameError: "",
      niceNameError: "",
      callingCodeError: "",
    };

    if (!regex.test(this.state.value.name)) {
      isError = true;
      errors.nameError = errmsg1;
    }
    if (this.state.value.name === "") {
      isError = true;
      errors.nameError = errmsg2;
    }
    if (!regex.test(this.state.value.isoName)) {
      isError = true;
      errors.isoNameError = errmsg1;
    }
    if (this.state.value.isoName === "") {
      isError = true;
      errors.isoNameError = errmsg2;
    }
    if (!regex.test(this.state.value.iso3Name)) {
      isError = true;
      errors.iso3NameError = errmsg1;
    }
    if (this.state.value.iso3Name === "") {
      isError = true;
      errors.iso3NameError = errmsg2;
    }
    if (!regex.test(this.state.value.niceName)) {
      isError = true;
      errors.niceNameError = errmsg1;
    }
    if (this.state.value.niceName === "") {
      isError = true;
      errors.niceNameError = errmsg2;
    }
    if (!regexcode.test(this.state.value.callingCode)) {
      isError = true;
      errors.callingCodeError = errmsg1;
    }
    if (this.state.value.callingCode === "") {
      isError = true;
      errors.callingCodeError = errmsg2;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  submit = () => {
    let data = this.state.value;

    const err = this.validate();

    if (!err) {
      this.props.AddCountry(this.state.value);
      this.setState({
        value: {
          name: "",
          isoName: "",
          iso3Name: "",
          niceName: "",
          callingCode: "",
          isActive: true,
        },
        nameError: "",
        isoNameError: "",
        iso3NameError: "",
        niceNameError: "",
        callingCodeError: "",
      });
      this.props.closeAddModel();
      this.props.resetPage();
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        name: "",
        isoName: "",
        iso3Name: "",
        niceName: "",
        callingCode: "",
        isActive: true,
      },
      nameError: "",
      isoNameError: "",
      iso3NameError: "",
      niceNameError: "",
      callingCodeError: "",
    });
    this.props.closeAddModel();
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.showAddModel}
          onHide={this.closeModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Country</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <div>
                      <Form.Group controlId="name">
                        <Form.Label> Name </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="name"
                          onChange={this.onChange}
                          value={this.state.value.name}
                        />
                        <div className="errStyle">{this.state.nameError}</div>
                      </Form.Group>
                    </div>

                    <div>
                      <Form.Group controlId="isoName">
                        <Form.Label> ISO Name </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="isoName"
                          onChange={this.onChange}
                          value={this.state.value.isoName}
                        />
                        <div className="errStyle">
                          {this.state.isoNameError}
                        </div>
                      </Form.Group>
                    </div>

                    <div>
                      <Form.Group controlId="iso3Name">
                        <Form.Label> ISO3 Name </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="iso3Name"
                          onChange={this.onChange}
                          value={this.state.value.iso3Name}
                        />
                        <div className="errStyle">
                          {this.state.iso3NameError}
                        </div>
                      </Form.Group>
                    </div>
                  </Col>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <div>
                      <Form.Group controlId="niceName">
                        <Form.Label> Nice Name </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="niceName"
                          onChange={this.onChange}
                          value={this.state.value.niceName}
                        />
                        <div className="errStyle">
                          {this.state.niceNameError}
                        </div>
                      </Form.Group>
                    </div>

                    <div>
                      <Form.Group controlId="callingCode">
                        <Form.Label> Country Calling Code</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="callingCode"
                          onChange={this.onChange}
                          value={this.state.value.callingCode}
                        />
                        <div className="errStyle">
                          {this.state.callingCodeError}
                        </div>
                      </Form.Group>
                    </div>

                    <div>
                      <label style={{ display: "flex", marginTop: "8px" }}>
                        <div style={{ marginRight: "30px" }}>
                          <span>Active</span>
                        </div>
                        <div style={{ marginTop: "-5px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={this.state.value.isActive}
                          />
                        </div>
                      </label>
                    </div>
                  </Col>
                </Row>{" "}
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddCountry;
